import { render, staticRenderFns } from "./DocumentDate.vue?vue&type=template&id=6f4a2368&scoped=true&"
import script from "./DocumentDate.vue?vue&type=script&lang=ts&"
export * from "./DocumentDate.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentDate.vue?vue&type=style&index=0&id=6f4a2368&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a2368",
  null
  
)

export default component.exports